// views/LoginView.js
import { useState } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider, ALLOWED_DOMAIN } from '../constants/firebase';
import logo from '../logo.svg';

function LoginView() {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    try {
      setError(null);
      setLoading(true);
      
      const result = await signInWithPopup(auth, googleProvider);
      const email = result.user.email;
      
      if (!email.endsWith(`@${ALLOWED_DOMAIN}`)) {
        await auth.signOut();
        setError(`Zugriff nur für @${ALLOWED_DOMAIN} E-Mail-Adressen erlaubt`);
      }
    } catch (err) {
      console.error('Login error:', err);
      
      if (err.code === 'auth/popup-closed-by-user') {
        setError('Login wurde abgebrochen');
      } else if (err.code === 'auth/popup-blocked') {
        setError('Popup wurde blockiert. Bitte erlaube Popups für diese Seite.');
      } else if (err.code === 'auth/cancelled-popup-request') {
        // Ignore multiple popup requests
        return;
      } else {
        setError('Login fehlgeschlagen: ' + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-950">
      <div className="text-center max-w-md p-8">
        <div className="mb-16 text-right">
          <img src={logo} className="App-logo " alt="logo" />
          <span className="bg-pink-500 text-white text-md rotate-12 -mt-2 inline-block font-semibold px-2 py-1 rounded-full">
            KI Studio
          </span>
        </div>

        <p className="text-gray-400 mb-8">Melde dich mit deinem Unternehmenskonto an</p>
        
        {error && (
          <div className="bg-red-500/10 border border-red-500 text-red-500 px-4 py-3 rounded-lg mb-6 text-sm">
            {error}
          </div>
        )}

        {/* Google Sign-In Button nach Branding Guidelines */}
        <button
          onClick={handleLogin}
          disabled={loading}
          className="w-full flex items-center justify-center gap-3 bg-white text-gray-700 px-6 py-3 rounded border border-gray-300 font-medium hover:bg-gray-50 transition-all shadow-sm hover:shadow disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? (
            <span className="text-gray-600">Wird geladen...</span>
          ) : (
            <>
              {/* Official Google "G" Logo */}
              <svg className="w-5 h-5" viewBox="0 0 48 48">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                <path fill="none" d="M0 0h48v48H0z"/>
              </svg>
              <span>Mit Google anmelden</span>
            </>
          )}
        </button>

        <p className="text-xs text-gray-500 mt-6">
          Nur für Mitarbeitende mit @{ALLOWED_DOMAIN} E-Mail-Adresse
        </p>
      </div>
    </div>
  );
}

export default LoginView;